module.exports = __webpack_public_path__ + "img/import_export.22ed0404.svg";